import React from "react";
import ReactDOM from "react-dom/client";

import "./app/style.css";
import App from "./app/app";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
